var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CcImage',{attrs:{"image":_vm.image,"link":_vm.link,"download":_vm.download,"is-android-image-download":_vm.isAndroidImageDownload}})
}
var staticRenderFns = []

export { render, staticRenderFns }